import React from "react"
import PropTypes from "prop-types"
import { useStyles } from "sheets/components/cells/StatCellBar.styles"

const StatCellBar = ({ barWidth, isCalculated }) => {
    const { classes } = useStyles({ isCalculated })
    return (
        <svg className={classes.statCellScale}>
            <rect height="20" width={barWidth} />
        </svg>
    )
}

StatCellBar.propTypes = {
    barWidth: PropTypes.number.isRequired,
    isCalculated: PropTypes.bool,
}

StatCellBar.defaultProps = {
    isCalculated: false,
}

export default StatCellBar
